// @ts-ignore
import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

// @ts-ignore
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  isShown = false;
  Shown = true;
  customOptionsSlider: any = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<div class="mygallery"><div class="prev"><i class="fa fa-chevron-left left"></i></div></div>', '<div class="mygallery"><div class="next"><i class="fa fa-chevron-right right"></i></div></div>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      700: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true,
  };
  customOptions: any = {
    loop: true,
    nav: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      940: {
        items: 3
      }
    },
  };
  customOptionsSlider2: any = {
    loop: false,
    nav: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      1800: {
        items: 2
      }
    },
  };

  // customleadSlider: any = {
  //   loop: true,
  //   nav: false,
  //   mouseDrag: true,
  //   touchDrag: true,
  //   pullDrag: false,
  //   dots: false,
  //   navSpeed: 500,
  //   navText: ['', ''],
  //   responsive: {
  //     940: {
  //       items: 1
  //     }
  //   },
  // };

  customleadSlider: any = {
    autoplay: true,
    // autoplayTimeout: 1000,
    loop: true,
    nav: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['<div class="mygallery"><div class="prev"><i class="fa fa-chevron-left left"></i></div></div>', '<div class="next"><i class="fa fa-chevron-right right"></i></div></div>'],
    responsive: {
      1200: {
        items: 1
      },
    },
  };
  constructor(private meta: Meta, private titleService: Title) { }
  toggleShow() {
    this.isShown = true;
    this.Shown = false;
  }
  toggleClient() {
    this.Shown = true;
    this.isShown = false;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    document.getElementById('about').style.backgroundColor = 'red';
    this.titleService.setTitle('Who We Are');
    // tslint:disable-next-line:max-line-length
    this.meta.updateTag({ name: 'description', content: 'We\'re a community of thinkers, creators, and builders committed to making digital work better. We design and deliver impactful software products that are used across industries and continents.' });
  }
}
